import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  floristImages: [],
  inventoryImages: [],
  videoProgress: 0,
};

const slice = createSlice({
  name: 'imagesGallery',
  initialState: initialState,
  reducers: {
    setGalleryImages: (state, { payload }) => {
      if (payload.isFlorist) {
        return {
          ...state,
          floristImages: payload.images,
        };
      } else {
        return {
          ...state,
          inventoryImages: payload.images,
        };
      }
    },

    setGalleryImagesProgress: (state, { payload }) => {
      if (payload.isFlorist) {
        const itemToBeUpdated = state.floristImages[payload.index];
        const updatedItem = {
          ...itemToBeUpdated,
          progress: payload.progress,
        };
        // Use slice instead of splice to avoid mutating the original array
        const updatedImages = [
          ...state.floristImages.slice(0, payload.index),
          updatedItem,
          ...state.floristImages.slice(payload.index + 1),
        ];
        return {
          ...state,
          floristImages: updatedImages,
        };
      } else {
        const itemToBeUpdated = state.inventoryImages[payload.index];
        const updatedItem = {
          ...itemToBeUpdated,
          progress: payload.progress,
        };
        // Use slice instead of splice to avoid mutating the original array
        const updatedImages = [
          ...state.inventoryImages.slice(0, payload.index),
          updatedItem,
          ...state.inventoryImages.slice(payload.index + 1),
        ];
        return {
          ...state,
          inventoryImages: updatedImages,
        };
      }
    },

    setVideoUploadProgress: (state, { payload }) => {
      return {
        ...state,
        videoProgress: payload.progress,
      };
    },
    setGalleryImagesUploading: (state, { payload }) => {
      if (payload.isFlorist) {
        return {
          ...state,
          floristImages: state.floristImages?.map((image) => ({
            ...image,
            uploading: payload.uploading,
          })),
        };
      } else {
        return {
          ...state,
          inventoryImages: state.inventoryImages?.map((image) => ({
            ...image,
            uploading: payload.uploading,
          })),
        };
      }
    },

    resetImagesGalleryState: () => {
      return initialState;
    },
  },
});

export const {
  setGalleryImages,
  setGalleryImagesProgress,
  resetImagesGalleryState,
  setGalleryImagesUploading,
  setVideoUploadProgress,
} = slice.actions;

export default slice.reducer;
